namespace App {
    export class AppElectronMessage {
        private appElectron: any = null;

        constructor() {
            this.appElectron = (window as any).AppElectron;
        }

        public onMessage(callback: any = null) {
            if (!this.appElectron) {
                return;
            }
            this.appElectron.receiveMessage("message-do-electron", (request: IMensagem) => {
                if (callback) {
                    callback(request)
                }
            });
        }
        public sendMessage(dadosMessage: any = null, callback: any = null) {
            if (!this.appElectron) {
                return;
            }
            
            this.appElectron.sendMessage(dadosMessage).then((response: any) => {
                if (callback) {
                    callback(response)
                }
            })
        }
    }
}